import {Component, Inject, OnInit, Input } from '@angular/core';

@Component({
    selector: 'data-generator-in-data',
    templateUrl: 'angular-blocworx/components/fields/data-generator/templates/in-data.html',
    styleUrls: ['angular-blocworx/components/fields/data-generator/data-generator.component.scss'],
})

export class DataGeneratorInData implements OnInit {

    @Input() field;
    @Input() scanStation;
    @Input() row;
    @Input() main;
    @Input() data;
    @Input() fc;

    ngOnInit(): void {

    }

}